import React from 'react';
import SectionHeader from './SectionHeader';
import { buildReferralDetailFields, hasReferralDetailContent } from './ReferralDetailsSection';
import './ContractInfo.css';

const ListingInfo = ({ listing, isExpanded = false, onToggle }) => {
  const formatDate = (dateStr) => {
    try {
      if (!dateStr) return 'N/A';
      const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) {
        const d = new Date(+m[1], +m[2] - 1, +m[3]);
        const parts = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).split(' ');
        if (parts.length >= 3 && parts[0].length === 3 && parts[0] !== 'May') parts[0] += '.';
        return parts.join(' ');
      }
      return dateStr;
    } catch { return dateStr || 'N/A'; }
  };

  const formatCurrency = (val) => {
    if (val == null) return 'N/A';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val); }
    catch { return 'Invalid Amount'; }
  };

  const formatPercent = (val) => {
    if (val == null) return 'N/A';
    return `${(Number(val) * 100).toFixed(2).replace(/\.?0+$/, '')}%`;
  };

  const renderSection = (title, fields) => {
    const visible = fields.filter(([, value]) => value !== null && value !== undefined && value !== '');
    if (visible.length === 0) return null;
    return (
      <div className="info-section">
        <h3>{title}</h3>
        <div className="info-grid">
          {visible.map(([label, value, formatter = (v) => v]) => (
            <div key={label} className="info-item">
              <span className="info-label">{label}:</span>
              <span className="info-value">{formatter(value)}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (!listing) return <div>No listing data available</div>;

  return (
    <div className="contract-info">
      <SectionHeader title="Listing Details" isExpanded={isExpanded} onToggle={onToggle} />

      {isExpanded && (
        <div className="contract-info-container">
          {renderSection('Property', [
            ['Street Address', listing.street_address],
            ['City', listing.city],
            ['State', listing.state],
            ['Zip Code', listing.zip_code],
            ['Year Built', listing.year_built],
            ['MLS #', listing.mls_number],
            ['Status', listing.status],
          ])}

          {renderSection('Pricing & Commission', [
            ['List Price', listing.listing_price, formatCurrency],
            listing.commission_percent != null
              ? ["Seller's Agent Commission", listing.commission_percent, formatPercent]
              : ["Seller's Agent Commission", listing.commission_amount, formatCurrency],
            ['Marketplace Fee', listing.marketplace_fee_percent, formatPercent],
            ['Marketplace Fee Minimum', listing.marketplace_fee_minimum_amount, formatCurrency],
            ['Listing Agent Share of Marketplace Fee', listing.listing_agent_share_of_marketplace_fee_percent, formatPercent],
            ["Cooperative Commission (Seller's Agent)", listing.cooperative_commission_percent_sellers_agent, formatPercent],
            ["Cooperative Commission (Buyer's Agent)", listing.cooperative_commission_percent_buyers_agent, formatPercent],
          ])}

          {renderSection('Key Dates', [
            ['Listing Date', listing.listing_date, formatDate],
            ['Expiration Date', listing.expiration_date, formatDate],
          ])}

          {listing.skyslope_listing_guid && renderSection('SkySlope', [
            ['SkySlope GUID', listing.skyslope_listing_guid],
            ['Sync Status', listing.skyslope_sync_status],
          ])}

          {hasReferralDetailContent(listing.referral_details) &&
            renderSection('Referral Details', buildReferralDetailFields(listing.referral_details))}
        </div>
      )}
    </div>
  );
};

export default ListingInfo;
